export const TAG_LABEL_MAX_LENGTH = 80;

export const DEFAULT_TAG_EMOJI = '🏷️';

export const TAG_EMOJI_OPTIONS: readonly string[] = [
  '🏷️',
  '⭐',
  '🔥',
  '🚀',
  '💡',
  '🎯',
  '✅',
  '📌',
  '🎨',
  '🧠',
  '🤖',
  '📈',
  '📊',
  '🔒',
  '⚡',
  '🌟',
  '🎉',
  '🚩',
  '✨',
  '🔧',
  '📁',
];

export const TAG_NAME_REQUIRED_MESSAGE = 'Tag name is required';

export const TAG_NAME_TOO_LONG_MESSAGE = `Tag name must be ${TAG_LABEL_MAX_LENGTH} characters or fewer`;

export const TAG_NAME_DUPLICATE_MESSAGE = 'A tag with this name already exists';
